(function() {
	'use strict';
	angular.module('app.setup')
		.controller('goalForm', goalForm);

	goalForm.$inject = ['$scope', '$rootScope', '$timeout', '$filter', 'strategicGoalsService', 'storeService'];
	function goalForm($scope, $rootScope, $timeout, $filter, strategicGoalsService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		// view model functions
		vm.goal = $scope.goal;
		vm.leanDirFactoryNdx = $scope.leanDirFactoryNdx;
		vm.isSaveButtonDisabled = false;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		vm.types = [{id: 'Site', text: 'Site'},{id: 'Department', text: 'Department'}];			
		vm.stateTypes = [{id: 'Open', text: 'Open'},{id: 'Archived', text: 'Archived'}];
		init();
		
		function init() {
			if (vm.action == 'Edit') {
				delete vm.goal.subGridOptions;
				vm.originalGoal = jQuery.extend({}, vm.goal, true); 
			} 
			else {
				vm.goal = {};
				vm.goal.type = 'Site';
				vm.goal.stateType = 'Open';
			}
		}

		function save() {
			vm.isSaveButtonDisabled = true;
			if (typeof vm.goal.ndx === 'undefined') {
				strategicGoalsService.addGoal(vm.goal, adminConfig.factory.id).then(function(message) {
					$scope.result(message, message == 'Goal created successfully');
					vm.isSaveButtonDisabled = false;
				});
			} else {
				var lastModified = (typeof vm.goal.lastModified === 'undefined') ? (new Date()).toUTCString(): (new Date(vm.goal.lastModified)).toUTCString();
				if (!angular.equals(vm.goal, vm.originalGoal)) {
					strategicGoalsService.updateGoal(vm.goal, lastModified, adminConfig.factory.id).then(function(message) {
						$scope.result('Goal updated successfully', message.data.id == vm.goal.ndx);
					});
				} else {
					$scope.result('', true);
				}
				vm.isSaveButtonDisabled = false;
			}
		}
		
		function close() {
			$scope.result('', false);
		}
	}
})();
